export default __webpack_public_path__ + "static/icon-refinancing-0922f1900d9effeede993b9c83de211d.png";